"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBarHeight = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _react = require("react");
var _checkoutGodModeHeightContext = require("../contexts/checkoutGodModeHeightContext");
var _useStoredState = require("./useStoredState");
const useBarHeight = (key)=>{
    const isResizing = (0, _react.useRef)(false);
    const [height, setHeight] = (0, _useStoredState.useStoredState)(key, 300);
    const { setHeight: setHeightContext } = (0, _checkoutGodModeHeightContext.useCheckoutGodModeHeight)();
    const changeHeight = (0, _react.useCallback)((newHeight)=>{
        setHeight(newHeight);
        // We need to be able to read the height also in packages/checkout which reads it from the context
        setHeightContext(newHeight);
    }, [
        setHeight,
        setHeightContext
    ]);
    (0, _checkoutUtils.useWindowEvent)('mousemove', (0, _react.useCallback)((e)=>{
        var _document_getSelection;
        if (!isResizing.current) {
            return;
        }
        const me = e;
        const newHeight = window.innerHeight - me.clientY;
        const heightLimit = window.innerHeight - 200;
        changeHeight(Math.max(100, Math.min(newHeight, heightLimit)));
        (_document_getSelection = document.getSelection()) === null || _document_getSelection === void 0 ? void 0 : _document_getSelection.empty();
        e.stopPropagation();
        e.preventDefault();
    }, [
        changeHeight
    ]));
    (0, _checkoutUtils.useWindowEvent)('mouseup', (0, _react.useCallback)(()=>{
        isResizing.current = false;
    }, []));
    (0, _checkoutUtils.useWindowEvent)('resize', (0, _react.useCallback)(()=>{
        if (height > window.innerHeight) {
            changeHeight(300);
        }
    }, [
        height,
        changeHeight
    ]));
    (0, _react.useEffect)(()=>{
        if (height > window.innerHeight) {
            changeHeight(300);
        }
    }, [
        height,
        changeHeight
    ]);
    return [
        height,
        (0, _react.useCallback)(()=>isResizing.current = true, [])
    ];
};
exports.useBarHeight = useBarHeight;
